/**
 * For Use in Intl.NumberFormat
 * we use LOCALE = id-ID in order to get money format always in Rp not IDR
 **/
export const LOCALE = 'id-ID';
